import { render } from "./IndirizzoConsegna.vue?vue&type=template&id=3326125b&scoped=true"
import script from "./IndirizzoConsegna.vue?vue&type=script&lang=js"
export * from "./IndirizzoConsegna.vue?vue&type=script&lang=js"

import "./IndirizzoConsegna.vue?vue&type=style&index=0&id=3326125b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3326125b"]])

export default __exports__